// src/pages/LeadersPage.js
import React, { useEffect, useState } from 'react'
import axios from 'axios'

function LeadersPage() {
  const [leaders, setLeaders] = useState([])
  const [error, setError] = useState('')

  useEffect(() => {
    const loadLeaders = async () => {
      try {
        const res = await axios.get('/leaders', { withCredentials: true })
        setLeaders(res.data)
      } catch (err) {
        setError(err.response?.data || 'Fehler beim Laden der Führungskräfte')
      }
    }
    loadLeaders()
  }, [])

  if (error) {
    return <p style={{ color: 'red' }}>{error}</p>
  }

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Führungskräfte</h2>
      {leaders.length === 0 ? (
        <p>Keine Führungskräfte gefunden.</p>
      ) : (
        <ul>
          {leaders.map(l => (
            <li key={l.id}>
              <strong>{l.email}</strong> <br />
              Role: {l.role} <br />
              Abteilung: {l.department} <br />
              Fokus: {l.leadership_focus} <br />
              <hr />
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default LeadersPage
